import { ERROR_CODES } from "@mozioinc/query";
import { Button, cn } from "@mozioinc/ui";
import { captureException } from "@sentry/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as WarningSvg } from "./assets/warning.svg";
import { Dialog } from "./dialog";
import type { TransNamespace } from "../types";
import type { ErrorCodes } from "@mozioinc/query";

type ErrorDialogProps = {
  title: string;
  message?: string;
  error: ErrorCodes;
  onClick?: () => void;
  loading?: boolean;
};

const ErrorDialog = ({
  title,
  message,
  error,
  onClick,
  loading,
}: ErrorDialogProps) => {
  const { t } = useTranslation<TransNamespace>("parking:error-dialog");

  const searchExpired = error === ERROR_CODES.SEARCH_EXPIRED;

  useEffect(() => {
    if (!searchExpired) {
      captureException(new Error(error));
    }
  }, [error, searchExpired]);

  return (
    <Dialog
      error={!searchExpired}
      open={true}
      icon={
        <WarningSvg
          className={cn("text-primary text-7xl", {
            "text-white": !searchExpired,
          })}
        />
      }
    >
      <h2 className="mb-1 mt-7 text-2xl font-bold leading-9">{title}</h2>
      <p className="mb-8 text-center">{message}</p>
      <Button className="w-full" disabled={loading} onClick={onClick}>
        {searchExpired ? t("Refresh") : t("Close")}
      </Button>
    </Dialog>
  );
};

export { ErrorDialog };
